/* eslint no-console:0 */
const Sentry = require("@sentry/react");
(function initSentryFromMeta() {
  const dsnEl = document.querySelector('meta[name="sentry-js-dsn"]');
  const envEl = document.querySelector('meta[name="sentry-environment"]');
  const dsn = dsnEl && dsnEl.getAttribute("content");
  if (!dsn) {
    return;
  }
  const environment = envEl && envEl.getAttribute("content");
  Sentry.init({
    dsn: dsn,
    environment: environment || undefined,
  });
})();

var componentRequireContext = require.context("components", true, /^(?!\.\/pages\/admin\/)/)
var ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);
